import { render, staticRenderFns } from "./ServicesReservationsAddedNewPayment.vue?vue&type=template&id=6cb052ea&scoped=true&"
import script from "./ServicesReservationsAddedNewPayment.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsAddedNewPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb052ea",
  null
  
)

export default component.exports